module.exports = __webpack_public_path__ + "static/media/close.2014ad49.png";